import { render } from "./guipei-lesson.vue?vue&type=template&id=2851e7a3&scoped=true"
import script from "./guipei-lesson.vue?vue&type=script&lang=js"
export * from "./guipei-lesson.vue?vue&type=script&lang=js"

import "./guipei-lesson.vue?vue&type=style&index=0&id=2851e7a3&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2851e7a3"]])

export default __exports__